// import { ShoppingCartIcon } from 'lucide-react';
import React, { useState } from 'react';
// import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const getLinkClass = (path) => {
    const isActive = location.pathname === path;
    return `${isActive ? 'bg-main-bg text-dark-text-color' : 'text-white_text'} 
            hover:bg-main-bg hover:text-dark-text-color transition-colors duration-300 py-2 px-4 rounded-md 
            ${isActive ? 'transform scale-105' : ''}`;
  };

  // const customer = useSelector((state) => state.auth.accessifyCustomer);


  return (
    <nav className="bg-bright-green p-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="text-2xl font-bold text-white_text">Accessify</div>

        {/* Menu for Desktop */}
        <div className="hidden md:flex space-x-6">
          <Link to="/" className={getLinkClass('/')}>Home</Link>
          {/* <Link to="/store" className={getLinkClass('/store')}>Store</Link> */}
          {/* <Link to="/services" className={getLinkClass('/services')}>Services</Link> */}

          <Link to="/blog" className={getLinkClass('/blog')}>Blog</Link>

          {/* {
            customer !== null
              ? <>
                <Link to="/account" className={getLinkClass('/account')}>Account</Link>
                <Link to="/cart" className={getLinkClass('/cart')}><ShoppingCartIcon /></Link>
              </>
              : <Link to="/auth" className={getLinkClass('/auth')}>SignUp / SignIn</Link>
          } */}
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setIsOpen(!isOpen)} className="text-white_text text-2xl">
            {isOpen ? 'X' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden ${isOpen ? 'block' : 'hidden'} mt-4`}>
        <div className="flex flex-col items-center">
          <Link to="/" className={getLinkClass('/')}>Home</Link>
          <Link to="/store" className={getLinkClass('/store')}>Store</Link>
          <Link to="/blog" className={getLinkClass('/blog')}>Blog</Link>

          {/* {
            customer !== null
              ? <>
                <Link to="/account" className={getLinkClass('/account')}>Account</Link>
                <Link to="/cart" className={getLinkClass('/cart')}>Cart</Link>
              </>
              : <Link to="/auth" className={getLinkClass('/auth')}>SignUp / SignIn</Link>
          } */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
